import styled from "styled-components";

export const LoginForm = styled.form`
  gap: 20px;
  width: calc(100vw - 80px);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const LoginInputRow = styled.div`
  gap: 10px;
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
`;

export const LoginFormDivider = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  margin-top: 20px;
  align-items: center;
  justify-content: center;

  &::before {
    width: 100%;
    z-index: 1;
    content: "";
    position: absolute;
    border-top: 1px solid ${(props) => props.theme.colors.border};
  }

  span {
    color: ${(props) => props.theme.colors.inputPlaceholder};
    z-index: 2;
    padding: 0 8px;
    position: relative;
    font-size: 1.4rem;
    background: ${(props) => props.theme.colors.white100};
    font-weight: 500;
  }
`;
